// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__iVqYG","LayoutMain":"Layout_LayoutMain__ONz8s"};